/**
 * Transform Yup per applicare il default quando tutti i figli di un oggetto
 * sono `null` o `undefined`.
 *
 * Quando `useController` registra i campi figli prima che il campo diventi
 * visibile, il form state contiene un oggetto con tutti i valori a undefined:
 * `{ opt1: undefined, opt2: undefined, ... }`.
 * Yup `.default()` non si attiva perché il valore è un oggetto (non `undefined`).
 * Questa transform rileva il caso e applica il default esplicitamente.
 */
export function transformAllNullChildrenToDefault(
  value: unknown,
  _originalValue: unknown,
  resolvedSchema: { getDefault: () => unknown },
) {
  if (
    value != null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.values(value).every(v => v == null)
  ) {
    return resolvedSchema.getDefault() ?? value;
  }
  return value;
}
